'use client';

import { useEffect } from 'react';
import markerSDK, { MarkerSdk } from '@marker.io/browser';

let markerInstance: MarkerSdk | null = null;

async function initMarkerIo() {
  const project = process.env.NEXT_PUBLIC_MARKER_PROJECT_ID;

  if (project && !markerInstance) {
    markerInstance = await markerSDK.loadWidget({ project });
  }
}

export default function MarkerIo() {
  useEffect(() => {
    initMarkerIo();
  }, []);

  return null;
}
